import React, { useEffect, useState, useRef, useContext } from 'react'
import './M_Table.css'
import { useTranslation } from "react-i18next"
import { Accordion, AccordionSummary, AccordionDetails, Badge, InputAdornment, InputBase, Menu, MenuItem, useMediaQuery } from '@mui/material'
import { Search, Close, PushPinOutlined, AddCircleOutlineOutlined, ArrowDownward, CloseRounded } from '@mui/icons-material'
import { DataTable } from 'primereact/datatable/datatable.cjs.js'
import { Column } from 'primereact/column/column.cjs.js'
import { ContextMenu } from 'primereact/contextmenu/contextmenu.cjs.js'
import { Paginator } from 'primereact/paginator/paginator.cjs.js'
// import * as XLSX from "xlsx"
import { CrudTable, AdvanceFilter, BufferService, filtersSortService, LoadingBar, LoadingContext, M_SwitchButton, M_Button, M_CheckBox, M_MessageBoard, NavigateContext } from '../../M_Components'

export function M_Table({ entityName, useSessionStorage, crud, onPassLine, onPassContext,
    tableHeight, manualId, rolePermissions, lineContext, extraButtons, removeContextItems,
    onHideLabels, toUseFilter, toUseFilterName, selectSingle, refresh, setRefresh,
    isParentTable, isChildTable, setParentLine, parentLine, field, roleName, FILTER,
    replaceFunctions, hasConfirmation, color, secondColor, value, valueIdField, CrudComponent, hiddenColumns = [],
    tablesOrder = [], pageUrl = '', onTablesOrderUpdate, extraTopFields, api = "main", columnTemplates = [], showTitle = false, title = entityName,
    onRowDoubleClick, filterComponent }) {

    const currentPageUrl = pageUrl


    const ctx = useContext(LoadingContext)
    const navCtx = useContext(NavigateContext)
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : "var(--color-black)"
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : "var(--color-black)"

    const nameForRole = roleName ? roleName : entityName
    const isSelectSingle = selectSingle !== undefined ? selectSingle : false
    const passFilterName = toUseFilterName ? toUseFilterName : 'Default'
    const passFilter = toUseFilter ? toUseFilter : new Map()
    const removeItem = removeContextItems ? removeContextItems : []
    const newButtons = extraButtons ? extraButtons : []
    const roles = rolePermissions ? rolePermissions : []
    const contextMenu = lineContext ? lineContext : []
    const entity = entityName
    const isPage = useSessionStorage !== undefined ? useSessionStorage : true
    const isCrud = crud !== undefined ? crud : true
    const adjustingTableMedia1 = useMediaQuery('(min-width:1542px)')
    const adjustingTableMedia2 = useMediaQuery('(min-width:1200px)')

    const headerSize = document.body.getElementsByClassName('p-datatable-header')[0]?.offsetHeight || 60
    const paginatorSize = document.body.getElementsByClassName('paginator')[0]?.offsetHeight || 60
    const tabSize = document.body.getElementsByClassName('divTabs')[0]?.offsetHeight || 50
    const tempSize = (document.body.offsetHeight - (headerSize + paginatorSize + tabSize + 3))
    const height = tableHeight ? tableHeight : tempSize

    const { t } = useTranslation()

    const maxWidth = useMediaQuery('(min-width:1050px)')
    const breakAuditWidth = useMediaQuery('(min-width:800px)')
    const breakAuditWidth2 = useMediaQuery('(min-width:500px)')

    const [id, setId] = useState(manualId === undefined ? sessionStorage.getItem('selectedTab') : manualId)
    const [rows, setRows] = useState([])
    const [columns, setColumns] = useState([])
    const [allColumns, setAllColumns] = useState([])
    const [companies, setCompanies] = useState([])
    const [firstRows, setFirstRows] = useState(0)
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [totalRows, setTotalRows] = useState(50)
    const [selectedColumns, setSelectedColumns] = useState([])
    const [selectedRows, setSelectedRows] = useState(value && [...value] || [])
    const [selectContext, setSelectContext] = useState(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('')
    const [orderInfo, setOrderInfo] = useState({ columnName: '', orderbool: false })
    const [metaPair, setMetaPair] = useState([])
    const [metaType, setMetaType] = useState([])
    const [advFilterString, setAdvFilterString] = useState('')
    const [showFilters, setShowFilters] = useState(false)
    const [anchorAF, setAnchorAF] = useState(null)
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
    const [valueAdd, setValueAdd] = useState(new Map())
    const [rowEdit, setRowEdit] = useState([])
    const [editMap, setEditMap] = useState(new Map())
    const [isCopy, setIsCopy] = useState(false)
    const [row, setRow] = useState(null)
    const [operation, setOperation] = useState('')
    const [filteredColumnModal, setFilteredColumnModal] = useState([])
    const [valueFilteredColumnModal, setValueFilteredColumnModal] = useState('')
    const [columnContextMenuString, setColumnContextmenuString] = useState({})
    const [anchorEls, setAnchorEls] = useState(null)
    const [anchorV, setAnchorV] = useState(null)
    const [views, setViews] = useState(passFilter)
    const [selectedView, setSelectedView] = useState(passFilterName)
    const [anchorEl, setAnchorEl] = useState(null)
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [pendingFilters, setPendingFilters] = useState(null) // Filters restored from login that need to be applied
    const pendingFiltersApplied = useRef(false) // Track if pending filters have been applied

    const [isTable, setIsTable] = useState(true)

    useEffect(() => {
        if (navCtx && navCtx.setTabPinnable) {
            navCtx.setTabPinnable(isTable)
        }
    }, [isTable])

    const [isLoaded, setIsLoaded] = useState(true)
    const [loading, setLoading] = useState(false)
    const [permissions, setPermissions] = useState([])

    const bufferService = new BufferService(entity, api)
    const filterService = new filtersSortService()
    const tablesOrderService = new BufferService('TablesOrder/saveOrder')
    const dt = useRef(null)
    const cm = useRef(null)
    const ccm = useRef(null)
    const openMenuPrint = Boolean(anchorEl)
    const openMenuHideColumns = Boolean(anchorEls)
    const openMenuViews = Boolean(anchorV)

    const auditService = new BufferService('audit')
    const [openAudit, setOpenAudit] = useState(false)
    const [auditData, setAuditData] = useState([])
    const [dataContextMenu, setDataContextMenu] = useState(null)

    //* as primeiras 3 colunas da ordem atual são sempre obrigatórias (atualiza com reorder)
    const isMandatoryColumn = (colName) => {
        return selectedColumns.slice(0, 3).some(c => (c.name || c.Name) === colName)
    }

    const columnContextMenu = [
        {
            label: t("OrderAsc"), icon: (<i className='pi pi-sort-amount-down-alt' style={{ color: color }}></i>), command: () => {
                setOrderInfo({ columnName: columnContextMenuString.target.title, orderbool: false })
                getWithFilters({ columnName: columnContextMenuString.target.title, orderbool: false })
            }
        },
        {
            label: t("OrderDesc"), icon: (<i className='pi pi-sort-amount-up-alt' style={{ color: color }}></i>), command: () => {
                setOrderInfo({ columnName: columnContextMenuString.target.title, orderbool: true })
                getWithFilters({ columnName: columnContextMenuString.target.title, orderbool: true })
            }
        },
        { label: t("Remove"), icon: (<i className="pi pi-times" style={{ color: color }}></i>), command: () => onColumnToggle(getColumnObj(columnContextMenuString.target.title)) },
    ]

    const sessionKeys = ['rows', 'columns', 'selectedColumns', 'globalFilterValue', 'metaPair', 'advFilterString', 'filteredColumnModal', 'valueFilteredColumnModal', 'selectedRows', 'metaType', 'showFilters', 'orderInfo', 'operation', 'isTable', 'rowEdit', 'valueAdd', 'isCopy', 'editMap', 'row', 'totalRows', 'views', 'selectedView', 'pageSize', 'page', 'firstRows', 'companies']

    useEffect(() => {
        if (isFirstLoop) {
            setIsLoaded(true)
            getSessionStorageData(id)
            getPermissions()
            setIsFirstLoop(false)
            if (isPage) {
                sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
            }
        }
        // eslint-disable-next-line
    }, [])

    const getSeverity = (status) => {
        switch (status) {
            // BL Statuses
            case 'Rejected':
                return '#ff0019';

            case 'Waiting for Approval (Cancel)':
                return '#ba002b';

            case 'Approved':
                return '#00b837';

            case 'Waiting for Approval':
                return '#ffb22e';

            case 'Waiting for Transporter Response':
                return '#ffb22e';

            case 'Rejected by Transporter':
                return '#ff0019';

            case 'Waiting for Approval (Changes)':
                return '#ff9130';

            case 'Draft':
                return '#3a71fc';

            // === DEMURRAGE STATUS ===
            case 'Clear':
                return '#00b837';
            case 'Partial':
                return '#ffb22e';
            case 'None':
                return '#ff0019'; 

            default: return 'var(--color-grey-dark2)';
            // ===================================
            

            // Receivable
            case 'Waiting':
                return '#ffb22e';
            
            case 'Error':
                return '#ff0019';
            
            case 'Error Primavera':
                return '#ff0019';
        }
    }

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const applyColumnOrder = (columns, order) => {
        if (!order || order.length === 0 || !columns || columns.length === 0) {
            return columns
        }

        const pageOrderRecord = order.find(o => o.PageUrl === currentPageUrl)
        if (!pageOrderRecord || !pageOrderRecord.ColumnsOrder || pageOrderRecord.ColumnsOrder.length === 0) {
            return columns
        }

        const columnsOrderArray = pageOrderRecord.ColumnsOrder

        // Criar map onde o índice no array é a ordem
        const orderMap = new Map()
        columnsOrderArray.forEach((colName, index) => {
            orderMap.set(colName, index)
        })

        // Ordenar as colunas baseado na posição do array
        const sortedColumns = [...columns].sort((a, b) => {
            const orderA = orderMap.get(a.Name) ?? orderMap.get(a.Header) ?? orderMap.get(a.NormalizedName)
            const orderB = orderMap.get(b.Name) ?? orderMap.get(b.Header) ?? orderMap.get(b.NormalizedName)

            if (orderA === undefined && orderB === undefined) return 0
            if (orderA === undefined) return 1
            if (orderB === undefined) return -1

            return orderA - orderB
        })

        return sortedColumns
    }

    const selectedIncomingValue = (data) => {
        if (value) {
            if (Array.isArray(value)) {
                const tempArray = []
                const newTempArray = []
                value.forEach(objValue => {
                    if (valueIdField) {
                        const temp = data.Items.filter(obj => obj[valueIdField] === objValue[valueIdField])
                        if (temp.length) tempArray.push(temp[0])
                    } else {
                        const temp = data.Items.filter(obj => obj?.Id === objValue?.Id)
                        if (temp.length) tempArray.push(temp[0])
                    }
                })
                if (selectedRows.length) {
                    let newTemp = []
                    selectedRows.forEach(obj => {
                        if (!tempArray.find(tempObj => tempObj.Id === obj.Id)) newTemp.push(obj)
                    })
                    newTemp.push(...tempArray)
                    newTempArray.push(...newTemp)
                } else {
                    newTempArray.push(...tempArray)
                }
                setSelectedRows([...newTempArray])
            } else {
                if (valueIdField && value[valueIdField]) {
                    const tempArray = data.Items.filter(obj => obj[valueIdField] === value[valueIdField])
                    setSelectedRows(tempArray)
                } else {
                    if (value?.Id) {
                        const tempArray = data.Items.filter(obj => obj?.Id === value?.Id)
                        setSelectedRows(tempArray)
                    }
                }
            }
        }
    }

    const getSessionStorageData = (sessionID) => {
        if (isPage) {
            const tempRs = sessionStorage.getItem(`${sessionID}rows`)
            const tempC = sessionStorage.getItem(`${sessionID}columns`)
            const tempSC = sessionStorage.getItem(`${sessionID}selectedColumns`)
            const tempGFV = sessionStorage.getItem(`${sessionID}globalFilterValue`)
            const tempMP = sessionStorage.getItem(`${sessionID}metaPair`)
            const tempAFS = sessionStorage.getItem(`${sessionID}advFilterString`)
            const tempFCM = sessionStorage.getItem(`${sessionID}filteredColumnModal`)
            const tempVFCM = sessionStorage.getItem(`${sessionID}valueFilteredColumnModal`)
            const tempMT = sessionStorage.getItem(`${sessionID}metaType`)
            const tempSF = sessionStorage.getItem(`${sessionID}showFilters`)
            const tempOI = sessionStorage.getItem(`${sessionID}orderInfo`)
            const tempO = sessionStorage.getItem(`${sessionID}operation`)
            const tempIT = sessionStorage.getItem(`${sessionID}isTable`)
            const tempRE = sessionStorage.getItem(`${sessionID}rowEdit`)
            const tempVA = sessionStorage.getItem(`${sessionID}valueAdd`)
            const tempIC = sessionStorage.getItem(`${sessionID}isCopy`)
            const tempEM = sessionStorage.getItem(`${sessionID}editMap`)
            const tempR = sessionStorage.getItem(`${sessionID}row`)
            const tempTR = sessionStorage.getItem(`${sessionID}totalRows`)
            const tempV = sessionStorage.getItem(`${sessionID}views`)
            const tempSV = sessionStorage.getItem(`${sessionID}selectedView`)
            const tempPS = sessionStorage.getItem(`${sessionID}pageSize`)
            const tempP = sessionStorage.getItem(`${sessionID}page`)
            const tempFR = sessionStorage.getItem(`${sessionID}firstRows`)
            const tempCnies = sessionStorage.getItem(`${sessionID}companies`)

            if ((tempRs !== "undefined" && tempRs && JSON.parse(tempRs)?.length !== 0 && tempC !== "undefined" && tempC && JSON.parse(tempC)?.length !== 0) && (tempSC || tempGFV || tempMP || tempAFS || tempFCM || tempVFCM || tempMT || tempSF || tempOI || tempO || tempIT || tempRE || tempVA || tempIC || tempEM || tempR || tempTR || tempV || tempSV || tempPS || tempP || tempFR || tempCnies)) {
                setSelectedColumns(JSON.parse(tempSC))
                setGlobalFilterValue(JSON.parse(tempGFV))
                setMetaPair(JSON.parse(tempMP))
                setAdvFilterString(JSON.parse(tempAFS))
                setFilteredColumnModal(JSON.parse(tempFCM))
                setValueFilteredColumnModal(JSON.parse(tempVFCM))
                setRows(JSON.parse(tempRs))
                setColumns(JSON.parse(tempC))
                setMetaType(JSON.parse(tempMT))
                setShowFilters(JSON.parse(tempSF))
                setOrderInfo(JSON.parse(tempOI))
                setOperation(JSON.parse(tempO))
                setIsTable(JSON.parse(tempIT))
                setRowEdit(JSON.parse(tempRE))
                setValueAdd(new Map(JSON.parse(tempVA)))
                setIsCopy(JSON.parse(tempIC))
                setEditMap(new Map(JSON.parse(tempEM)))
                setRow(JSON.parse(tempR))
                setTotalRows(JSON.parse(tempTR))
                setViews(new Map(JSON.parse(tempV)))
                setSelectedView(JSON.parse(tempSV))
                setPageSize(JSON.parse(tempPS))
                setPage(JSON.parse(tempP))
                setFirstRows(JSON.parse(tempFR))
                setCompanies(JSON.parse(tempCnies))
                setIsLoaded(false)
                return
            }

            // Store restored filters to apply after columns are loaded (after login)
            if (tempMP && tempMP !== "undefined" && tempMP !== "null") {
                const restoredFilters = {
                    metaPair: JSON.parse(tempMP),
                    orderInfo: tempOI && tempOI !== "undefined" && tempOI !== "null" ? JSON.parse(tempOI) : null,
                    pageSize: tempPS && tempPS !== "undefined" && tempPS !== "null" ? JSON.parse(tempPS) : null,
                    selectedView: tempSV && tempSV !== "undefined" && tempSV !== "null" ? JSON.parse(tempSV) : null
                }
                setPendingFilters(restoredFilters)
            }
        }
        options()
        setViews(new Map(views.set('Default', '?page=1&pagesize=20')))
    }

    useEffect(() => {
        if (tablesOrder && tablesOrder.length > 0 && columns.length > 0 && currentPageUrl) {

            const pageOrderRecord = tablesOrder.find(o => o.PageUrl === currentPageUrl)

            if (pageOrderRecord && pageOrderRecord.ColumnsOrder && pageOrderRecord.ColumnsOrder.length > 0) {
                const orderedColumns = applyColumnOrder(columns, tablesOrder)

                // Só atualiza se a ordem for diferente
                const currentOrder = columns.map(c => c.Name).join(',')
                const newOrder = orderedColumns.map(c => c.Name).join(',')

                if (currentOrder !== newOrder) {
                    setColumns(orderedColumns)
                    setSelectedColumns(orderedColumns)
                    setFilteredColumnModal(orderedColumns)
                }
            }
        }
    }, [tablesOrder, currentPageUrl, columns.length])

    // Apply pending filters after columns are loaded (restored from login)
    useEffect(() => {
        if (pendingFilters && columns.length > 0 && rows.length > 0 && !pendingFiltersApplied.current) {
            pendingFiltersApplied.current = true // Mark as applied to prevent re-running

            const { metaPair: restoredMetaPair, orderInfo: restoredOrderInfo, pageSize: restoredPageSize } = pendingFilters

            if (restoredMetaPair && restoredMetaPair.length > 0) {

                setMetaPair(restoredMetaPair)
                if (restoredOrderInfo) setOrderInfo(restoredOrderInfo)
                if (restoredPageSize) setPageSize(restoredPageSize)

                const filterUrl = filterService.advancedSearch(restoredMetaPair, true)
                setAdvFilterString(filterUrl)

                // Build and execute query with restored filters
                const newUrl = filterService.queryBuilder(page, restoredPageSize || pageSize, restoredOrderInfo || orderInfo, restoredMetaPair, FILTER)
                setLoading(true)
                bufferService.filter(newUrl).then(res => {
                    if (res.name === 'AxiosError') {
                        toastMessages('error', res.message, '')
                        setRows([])
                        setTotalRows([])
                        setLoading(false)
                        return
                    }
                    const items = Array.isArray(res) ? res : res.Items || []
                    const total = Array.isArray(res) ? res.length : res.TotalItems || 0
                    setRows(items)
                    setTotalRows(total)
                    setLoading(false)
                    setPendingFilters(null) // Clear after apply the filters successfully
                })
            } else {
                setPendingFilters(null)
            }
        }
    }, [pendingFilters, columns.length, rows.length])

    // Function to save filters for pinned tab
    const saveFiltersForPinnedTab = () => {
        const tabValue = id ? JSON.parse(id) : null

        if (!navCtx?.updateTabFilters || !navCtx?.isTabPinned || !tabValue) {
            return
        }

        if (navCtx.isTabPinned(tabValue)) {
            // console.log('Saving filters for pinned tab:', tabValue)
            navCtx.updateTabFilters(tabValue)
        }
    }

    // eslint-disable-next-line
    useEffect(() => {
        if (refresh) {
            setRefresh(false)
            setSelectedRows([])
            if (onPassLine) onPassLine([])
            changeView(selectedView)
        }
        if (onHideLabels) onHideLabels(maxWidth)
        if (manualId === undefined) {
            const newId = sessionStorage.getItem('selectedTab')
            if (newId !== id) {
                setId(newId)
                getSessionStorageData(newId)
            }
        } else {
            if (manualId !== id) {
                setId(manualId)
                getSessionStorageData(manualId)
            }
        }
    })

    useEffect(() => {
        if (isPage) {
            sessionKeys.forEach((key) => {
                sessionStorageMachine(id, key, key)
            })
        }
        // eslint-disable-next-line
    }, [id, rows, columns, selectedColumns, globalFilterValue, metaPair, advFilterString, filteredColumnModal, valueFilteredColumnModal, selectedRows, metaType, showFilters, orderInfo, operation, isTable, rowEdit, valueAdd, isCopy, editMap, row, totalRows, views, selectedView, pageSize, page, firstRows, companies])

    const options = () => {
        setMetaType([])
        setColumns([])
        setSelectedColumns([])
        setFilteredColumnModal([])
        bufferService.options().then(data => {
            if (data.name === 'AxiosError') {
                toastMessages('error', data.message, '')
                return
            }
            let tempArray = []
            let tempCompanies = JSON.parse(sessionStorage.getItem('companies'))
            if (!tempCompanies || tempCompanies[0].AccountId === null || tempCompanies[0].AccountId === undefined) {
                tempCompanies = []
            }
            setCompanies(tempCompanies)
            data?.forEach((element) => {
                setMetaType(prev => [...prev, {
                    'metaName': element.Name,
                    'metaType': element.Type,
                    'metaDisplay': element.NormalizedName,
                    'metaIsList': element.IsHiddenList,
                    'metaIsEdit': element.IsHiddenEdit,
                    'metaMinLen': element.MinLen,
                    'metaMaxLen': element.MaxLen,
                    'metaIsRequired': element.IsRequired,
                    'metaIsForeignKey': element.IsForeignKey,
                    'metaForeignKeyName': element.ForeignKeyName,
                    'metaForeignTableName': element.ForeignTableName,
                    'metaForeignTableToPassId': element.ForeignTableToPassId,
                    'metaGroupByInfo': element.GroupByInfo
                }])
                if (element.IsHiddenList) return

                //Filtro para esconder colunas
                const shouldHideColumn = hiddenColumns.some(hiddenCol =>
                    element.Name === hiddenCol ||
                    element.NormalizedName === hiddenCol ||
                    element.Header === hiddenCol
                )

                if (shouldHideColumn) return

                tempArray.push({ ...element, name: element.Name })
                setColumns(prev => [...prev, { ...element, name: element.Name }])
                setSelectedColumns(prev => [...prev, { ...element, name: element.Name }])
                setFilteredColumnModal(prev => [...prev, { ...element, name: element.Name }])

            })

            const orderedColumns = applyColumnOrder(tempArray, tablesOrder)
            setAllColumns(tempArray)
            changeView(selectedView)
        })
    }

    const saveColumnOrder = async (newColumns) => {
        if (!currentPageUrl) {
            console.error('M_Table: pageUrl é obrigatório e não pode ser null/undefined')
            return // Não guarda se não tiver pageUrl definido
        }

        const request = {
            PageUrl: currentPageUrl,
            ColumnsOrder: newColumns.map(col => col.Name || col.Header)
        }

        try {
            await tablesOrderService.post(request)
            ctx.toastMessages('success', '', t("SuccessColumnOrder"))
            if (onTablesOrderUpdate) {
                onTablesOrderUpdate(request)
            }
        } catch (error) {
            console.error('Error saving column order:', error)
            ctx.toastMessages('error', '', t("ErrorColumnOrder"))
        }
    }

    const onColReorder = (e) => {
        // console.log('onColReorder called', e)
        // e.columns contém as colunas na nova ordem
        const newOrder = e.columns.map(col => {
            return selectedColumns.find(sc => sc.Name === col.props.field)
        }).filter(Boolean)

        // console.log('New order after drag:', newOrder.map(c => c.Name))

        setSelectedColumns([...newOrder])
        setColumns([...newOrder])
        setFilteredColumnModal([...newOrder])
        saveColumnOrder(newOrder)
    }

    const get = (passData) => {
        setRows([])
        if (!isLoaded) setLoading(true)
        const newUrl = filterService.queryBuilder(page, pageSize, undefined, undefined, FILTER)
        bufferService.filter(newUrl).then(data => {
            if (data.name === 'AxiosError') {
                toastMessages('error', data.message, '')
                setRows([])
                setTotalRows([])
                setIsLoaded(false)
                setLoading(false)
                return
            }

            // Suporta tanto array direto quanto objeto com Items
            const items = Array.isArray(data) ? data : data.Items || []
            const total = Array.isArray(data) ? data.length : data.TotalItems || 0

            selectedIncomingValue({ Items: items, TotalItems: total })

            setTotalRows(total)
            setRows(items)
            setIsLoaded(false)
            setLoading(false)
        })
    }

    // eslint-disable-next-line
    const deRetardationString = (data) => {
        return data.replace(/([A-Z])/g, ' $1').trim()
    }

    const getType = (input) => {
        if (input === 'true' || input === 'false') return 'boolean'
        else if (/^-?\d+$/.test(input)) return 'int32'
        else return 'string'
    }

    const getValue = (input) => {
        if (input === 'true') return true
        else if (input === 'false') return false
        else if (/^-?\d+$/.test(input)) return parseInt(input)
        else if (/^-?\d*\.\d+$/.test(input)) return parseFloat(input)
        else return input
    }

    const getPermissions = () => {
        roles.forEach((role) => {
            if (role.match(nameForRole)) {
                const tempPerm = role.split(nameForRole)[1]
                setPermissions(prev => [...prev, tempPerm])
            }
        })
    }

    const saveFilter = (newView) => {
        setLoading(true)
        let url = filterService.advancedSearch(metaPair, true)
        setAdvFilterString(url)
        if (orderInfo.columnName) url = filterService.orderBy(orderInfo, url)
        const tempPageString = filterService.pagination(page, pageSize)
        url = tempPageString.concat(url)
        const newUrl = filterService.queryBuilder(page, pageSize, orderInfo, metaPair, FILTER)
        bufferService.filter(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            const items = Array.isArray(res) ? res : res.Items || []
            const total = Array.isArray(res) ? res.length : res.TotalItems || 0

            selectedIncomingValue({ Items: items, TotalItems: total })

            setTotalRows(total)
            setRows(items)
            setLoading(false)
            setIsLoaded(false)
        })
        setViews(new Map(views.set(newView, url)))
        setSelectedView(newView)
    }

    const changeView = (viewName) => {
        if (!isLoaded) setLoading(true)
        setAdvFilterString('')
        setMetaPair([])
        setOrderInfo({ columnName: '', orderbool: false })
        setSelectedView(viewName)
        const url = views.get(viewName)
        let objectFilterArray = []
        let objectOrderBy = { columnName: '', orderbool: false }
        if (url === undefined) {
            get()
            return
        }
        url.split('&').forEach((elem) => {
            if (elem.includes("filter")) {
                setAdvFilterString('&' + elem)
                let stringFilter = elem.split('filter=')[1]
                stringFilter = stringFilter.split(' and ')
                stringFilter.forEach((el) => {
                    const tempArray = el.split(' ')
                    let tempObj
                    let tempOp = ''
                    if (tempArray[0] == '') tempArray.shift()
                    tempObj = metaType.filter(meta => meta.metaName === tempArray[0])
                    if (tempArray[1] === 'eq') {
                        if (tempArray[1] === 'eq' && tempArray[2].includes('$')) tempOp = 'Contains'
                        else tempOp = 'Equals'
                    }
                    if (tempArray[1] === 'Greater') tempOp = 'Greater'
                    let objectFilter
                    if (tempObj.length) {
                        objectFilter = {
                            name: tempArray[0],
                            display: tempObj[0].metaDisplay,
                            type: tempObj[0].metaType,
                            operation: tempOp,
                            value: tempArray[2].replaceAll("'", '').replaceAll("$", '')
                        }
                    } else {
                        if (tempArray[0].includes('contains')) {
                            tempOp = 'Contains'
                            objectFilter = {
                                name: tempArray[0].split(',')[0].replace('contains(', ''),
                                display: deRetardationString(tempArray[0].split(',')[0].replace('contains(', '')),
                                type: 'string',
                                operation: tempOp,
                                value: decodeURIComponent(tempArray[0]).split(',')[1].replace(')', '').replaceAll("'", '')
                            }
                        } else {
                            objectFilter = {
                                name: tempArray[0],
                                display: deRetardationString(tempArray[0]),
                                type: getType(tempArray[2].replaceAll("'", '').replaceAll("$", '')),
                                operation: tempOp,
                                value: getValue(tempArray[2].replaceAll("'", '').replaceAll("$", ''))
                            }
                        }
                    }
                    objectFilterArray.push(objectFilter)
                })
            }
            if (elem.includes('order')) {
                let stringOrder = elem.split('orderby=')[1]
                stringOrder = stringOrder.split(' ')
                let tempBool = ''
                if (stringOrder[1] === 'asc') tempBool = false
                if (stringOrder[1] === 'desc') tempBool = true
                objectOrderBy = { columnName: stringOrder[0].toUpperCase(), orderbool: tempBool }
            }
        })
        setMetaPair(objectFilterArray)
        setOrderInfo(objectOrderBy)
        const newUrl = filterService.queryBuilder(page, pageSize, objectOrderBy, objectFilterArray, FILTER)
        bufferService.filter(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            // Suporta tanto array direto quanto objeto com Items
            const items = Array.isArray(res) ? res : res.Items || []
            const total = Array.isArray(res) ? res.length : res.TotalItems || 0

            selectedIncomingValue({ Items: items, TotalItems: total })

            setTotalRows(total)
            setRows(items)
            setLoading(false)
            setIsLoaded(false)
        })
    }

    const deleteView = (name) => {
        views.delete(name)
        setViews(new Map(views))
        if (selectedView === name) setSelectedView('')
    }

    const createView = (e) => {
        get(allColumns)
        setMetaPair([])
        setSelectedView('')
        handleClickCloseViews()
        setAnchorAF(document.getElementById('advFilter'))
    }

    const getWithFilters = (ord, newPage, newRows, adv) => {
        setLoading(true)
        const customPage = newPage ? newPage : page
        const customPageSize = newRows ? newRows : pageSize
        const customOrder = ord ? ord : orderInfo
        const customAdv = adv ? adv : metaPair
        let url = filterService.queryBuilder(customPage, customPageSize, customOrder, customAdv, FILTER)
        bufferService.filter(url).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            // Suporta tanto array direto quanto objeto com Items
            const items = Array.isArray(res) ? res : res.Items || []
            const total = Array.isArray(res) ? res.length : res.TotalItems || 0

            selectedIncomingValue({ Items: items, TotalItems: total })

            setTotalRows(total)
            setRows(items)
            setLoading(false)
            setIsLoaded(false)
        })
    }

    const addMetaPair = (filter) => {
        let tempBol = false
        if (metaPair.length) {
            metaPair.forEach((element) => {
                if (element.name === filter.name) tempBol = true
            })
            if (tempBol === true) {
                setMetaPair(metaPair.map((elem) => elem.name === filter.name ? { ...elem, operation: filter.operation, value: filter.value } : elem))
            } else {
                setMetaPair(prev => [...prev, filter])
            }
        } else {
            setMetaPair([filter])
        }
    }

    const submitFilters = (input, order) => {
        setLoading(true)
        const data = input ? input : metaPair
        const passOrder = order ? order : orderInfo
        let url = filterService.queryBuilder(page, pageSize, passOrder, data, FILTER)
        bufferService.filter(url).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            const items = Array.isArray(res) ? res : res.Items || []
            const total = Array.isArray(res) ? res.length : res.TotalItems || 0

            selectedIncomingValue({ Items: items, TotalItems: total })

            setTotalRows(total)
            setRows(items)
            setLoading(false)
            setIsLoaded(false)

            // Save filters to database if tab is pinned
            saveFiltersForPinnedTab()
        })
        return url
    }

    const deleteAllFilters = () => {
        setLoading(true)
        setAdvFilterString('')
        setMetaPair([])
        const newUrl = filterService.queryBuilder(page, pageSize, orderInfo, undefined, FILTER)
        bufferService.filter(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            const items = Array.isArray(res) ? res : res.Items || []
            const total = Array.isArray(res) ? res.length : res.TotalItems || 0

            selectedIncomingValue({ Items: items, TotalItems: total })

            setTotalRows(total)
            setRows(items)
            setLoading(false)
            setIsLoaded(false)

            // Save filters to database if tab is pinned
            saveFiltersForPinnedTab()
        })
    }

    const deleteFilter = (filterName) => {
        const tempMeta = metaPair.filter(elem => elem.name !== filterName)
        setMetaPair(tempMeta)
        submitFilters(tempMeta)
    }

    const order = (e) => {
        if (e.target.id === 'columnTable') {
            setLoading(true)
            const column = e.target.title
            let newOrderInfo = {}
            if (orderInfo.columnName === column) {
                if (orderInfo.orderbool === false) {
                    const resetOrder = { columnName: '', orderbool: false }
                    setOrderInfo(resetOrder)
                    getWithFilters(resetOrder)
                    return
                }
                newOrderInfo = { columnName: column, orderbool: !orderInfo.orderbool }
            } else {
                newOrderInfo = { columnName: column, orderbool: true }
            }
            setOrderInfo(newOrderInfo)
            let url = filterService.orderBy(newOrderInfo, advFilterString)
            const tempPageString = filterService.pagination(page, pageSize)
            url = tempPageString.concat(url)
            let newUrl = filterService.queryBuilder(page, pageSize, newOrderInfo, metaPair, FILTER)
            bufferService.filter(newUrl).then(res => {
                if (res.name === 'AxiosError') {
                    toastMessages('error', res.message, '')
                    setRows([])
                    setTotalRows([])
                    setLoading(false)
                    setIsLoaded(false)
                    return
                }

                const items = Array.isArray(res) ? res : res.Items || []
                const total = Array.isArray(res) ? res.length : res.TotalItems || 0

                selectedIncomingValue({ Items: items, TotalItems: total })

                setTotalRows(total)
                setRows(items)
                setLoading(false)
                setIsLoaded(false)
            })
        }
    }

    const clear = () => {
        getWithFilters()
        toastMessages('success', '', t("RefreshTable"))
    }

    const getColumnObj = (header) => {
        const tempArray = columns.filter(obj => obj.Header === header)
        return tempArray[0]
    }

    const onColumnToggle = (data, event) => {
        // Block toggle for mandatory columns (first 3)
        if (isMandatoryColumn(data.name || data.Name)) return
        let tempArray = []
        if (selectedColumns.find((element) => element.Name === data.name)) {
            tempArray = selectedColumns.filter(el => el.Name !== data.name)
            setSelectedColumns(tempArray)
            return
        } else {
            setSelectedColumns(prev => [...prev, data])
            return
        }
    }

    const isColumnChecked = (data) => {
        if (selectedColumns.find((element) => element.name === data)) return true
        else return false
    }

    const filterColumnModal = (data) => {
        setValueFilteredColumnModal(data)
        const regex = new RegExp(data)
        const tempElem = columns.filter((elem) => regex.test(elem.name))
        setFilteredColumnModal(tempElem)
    }

    const handleOpenDelete = (line) => {
        if (Array.isArray(line) && line.length > 0) {
            setDataContextMenu(null)
            setOpenConfirmDelete(true)
        } else if (line && typeof line === 'object' && Object.keys(line).length > 0) {
            setDataContextMenu(line)
            setOpenConfirmDelete(true)
        } else {
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    const handleCloseConfirmDelete = () => {
        setDataContextMenu(null)
        setOpenConfirmDelete(false)
    }

    const handleOpenDialogAdd = () => {
        setOperation('Create')
        setRow(null)
        setIsTable(false)
    }

    const handleOpenCopy = (selected) => {
        const row = selected ? selected : null
        if (row) {
            setIsCopy(true)
            setRow(row)
            setOperation('Copy')
            setIsTable(false)
        } else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    const handleOpenEdit = (selected) => {
        const row = selected ? selected : null
        if (row) {
            setRow(row)
            setOperation('Edit')
            setIsTable(false)
        } else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    const handleView = (selected) => {
        const row = selected ? selected : null
        if (row) {
            setRow(row)
            setOperation('View')
            setIsTable(false)
        } else {
            setIsTable(true)
            toastMessages('error', '', t("SelectedLine"))
        }
    }

    const onlyVisibleItems = (lineArray) => {
        const dict = new Map()
        const objectArray = []
        lineArray.forEach(element => {
            let tempBol = false
            Object.entries(element).forEach(keyValue => {
                tempBol = false
                selectedColumns.forEach(header => {
                    if (header.Name === keyValue[0]) tempBol = true
                })
                if (tempBol) dict.set(keyValue[0], keyValue[1])
            })
            objectArray.push(Object.fromEntries(dict))
        })
        return objectArray
    }

    const nextChar = (char) => {
        return String.fromCharCode(char.charCodeAt(0) + 1)
    }

    const exportExcel = () => {
        const exportFilter = filterService.queryBuilder(page, pageSize, orderInfo, metaPair, FILTER)
        const filterOnly = exportFilter
            .replace(/\?page=\d+&pagesize=\d+/, '')
            .replace(/^&/, '?')
        const url = `${bufferService.url}${entity}/excel${filterOnly || ''}`
        ctx.setIsLoad(true)
        fetch(url, {
            headers: { 'Authorization': 'Bearer ' + localStorage.getItem('tokenMaeil') }
        })
        .then(res => {
            if (!res.ok) throw new Error('Export failed')
            return res.blob()
        })
        .then(blob => {
            const objectUrl = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = objectUrl
            link.setAttribute('download', `${entity}_${new Date().toISOString().split('T')[0]}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(objectUrl)
            ctx.setIsLoad(false)
            toastMessages('success', '', t('ExportSuccess'))
        })
        .catch(err => {
            ctx.setIsLoad(false)
            toastMessages('error', err.message, t('Error'))
        })
        handleCloseMenuPrint()
    }

    /*
    // const importExcel = (e) => {
        const file = e.target.files[0]
        const importArray = []
        file.arrayBuffer().then(el => {
            const workbook = XLSX.read(el)
            const sheetName = workbook.SheetNames
            const sheet = workbook.Sheets[sheetName]
            const sheetRange = sheet["!ref"]
            const regexstart = new RegExp("([A-Z])")
            const sheetRangeSplit = sheetRange.split(":")
            const sheetRangeStartSplit = sheetRangeSplit[0].split(regexstart)
            const sheetColStart = sheetRangeStartSplit[1]
            const sheetRowStart = sheetRangeStartSplit[2]
            const sheetRangeEndSplit = sheetRangeSplit[1].split(regexstart)
            const sheetColEnd = sheetRangeEndSplit[1]
            const sheetRowEnd = sheetRangeEndSplit[2]
            for (let e = nextChar(sheetRowStart); e <= sheetRowEnd; e++) {
                const tempDict = new Map()
                for (let i = sheetColStart; i !== nextChar(sheetColEnd); i = nextChar(i)) {
                    if (sheet[i + e]) {
                        tempDict.set(sheet[i + 1].v, sheet[i + e].v)
                        continue
                    }
                    tempDict.set(sheet[i + 1].v, "")
                }
                importArray.push(Object.fromEntries(tempDict))
            }
            importArray.forEach((element) => {
                post(element).then(data => {
                    if (data.name === "AxiosError") {
                        toastMessages("error", data.response.data.errors, t("Error"))
                        return
                    }
                    toastMessages("success", "", t("AddSuccess"))
                    getWithFilters()
                })
            })
        })
        handleCloseMenuPrint()
    }
    */

    const onSelectionChange = (e) => {
        let tempValue = []
        if (isSelectSingle) {
            tempValue = [e.value]
        } else {
            if (e.type === 'all') {
                if (e.value.length) {
                    selectedRows.forEach(obj => {
                        if (!e.value.find(rowObj => rowObj.Id === obj.Id)) tempValue.push(obj)
                    })
                    tempValue.push(...e.value)
                } else {
                    selectedRows.forEach(obj => {
                        if (!rows.find(rowObj => rowObj.Id === obj.Id)) tempValue.push(obj)
                    })
                }
            } else {
                tempValue = [...e.value]
            }
        }
        if (isParentTable) {
            setParentLine(tempValue)
            onPassLine(tempValue)
        }
        if (onPassLine) onPassLine(tempValue)
        setSelectedRows([...tempValue])
    }

    const post = async (data) => {
        setLoading(true)
        const res = await bufferService.post(data).then(response => {
            setLoading(false)
            return response
        })
        const dataRes = await res
        return dataRes
    }

    const postDelete = () => {
        let tempArray = []
        if (dataContextMenu) {
            bufferService.delete(dataContextMenu.Id).then(data => {
                if (data.name === 'AxiosError') {
                    if (data?.response?.data) {
                        toastMessages('error', data.response.data)
                        setOpenConfirmDelete(false)
                    } else {
                        toastMessages('error', data.response.data.errors, t("SelectedMultiLine"))
                    }
                } else {
                    setDataContextMenu(null)
                    toastMessages('success', '', t("RemoveLine"))
                    setOpenConfirmDelete(false)
                    getWithFilters()
                }
            })
        } else {
            if (selectedRows.length) tempArray = selectedRows
        }
        tempArray.forEach((elem) => {
            // console.log(elem.Id)
            bufferService.delete(elem.Id).then(data => {
                if (data.name === 'AxiosError') {
                    if(data.response.status === 422 && data.response.data.title && data.response.data.title === "Regra de negócio violada") {
                        toastMessages('error', data.response.data.detail, '')
                        setOpenConfirmDelete(false)
                        return
                    }
                    toastMessages('error', data.response.data, '')
                } else {
                    setSelectedRows(null)
                    toastMessages('success', '', t("RemoveLine"))
                    setOpenConfirmDelete(false)
                    getWithFilters()
                }
            })
        })
    }

    const onPage = (event) => {
        setFirstRows(event.first)
        const newPage = event.page + 1
        setPage(newPage)
        setPageSize(event.rows)
        getWithFilters('', newPage, event.rows)
    }

    const rightClick = (e) => {
        if (e.target.id !== "columnTable") return
        setColumnContextmenuString(e)
        ccm.current.show(e)
    }

    const handleClickOpenMenuPrint = (event) => { setAnchorEl(event.currentTarget) }
    const handleCloseMenuPrint = () => { setAnchorEl(null) }
    const handleClickOpenMenuHideColumns = (event) => { setAnchorEls(event.currentTarget) }
    const handleCloseMenuHideColumns = () => { setAnchorEls(null) }
    const handleClickOpenViews = (event) => { setAnchorV(event.currentTarget) }
    const handleClickCloseViews = () => { setAnchorV(null) }
    const handleOpenAdvancedFilterMenu = (event) => { setAnchorAF(event.currentTarget) }

    const toastMessages = (type, alert, string) => { ctx.toastMessages(type, alert, string) }

    const extraButtonFunction = (data, func, need) => {
        const tempNeed = need !== null ? need : true
        if (data === undefined && tempNeed) {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        sessionStorage.setItem('contextLine', JSON.stringify(data))
        if (value) {
            func(selectedRows)
        } else {
            func(data)
        }
    }

    // ── Header ────────────────────────────────────────────────────────────────
    const header = (
        <div>
            {/* Title */}
            {showTitle && (
                <div style={{
                    padding: '16px 20px',
                    backgroundColor: '#f8f9fa',
                    borderBottom: '1px solid #e9ecef',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <h1 style={{
                            margin: 0,
                            fontSize: '2rem',
                            fontWeight: 600,
                            color: color
                        }}>
                            {t(title)}
                        </h1>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {totalRows > 0 && (
                            <span style={{
                                padding: '4px 12px',
                                backgroundColor: color || '#0d6efd',
                                color: 'white',
                                borderRadius: '20px',
                                fontSize: '0.9rem',
                                fontWeight: 500,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            }}>
                                {totalRows} {t('items')}
                            </span>
                        )}
                    </div>
                </div>
            )}

            {/* ── Filter component — renders between title and toolbar ── */}
            {filterComponent && (
                <div>{filterComponent}</div>
            )}

            {/* Toolbar */}
            <div className="display header">
                <div className="menuIcon">
                    <M_Button
                        tooltip={t("RefreshTable")}
                        label={t("RefreshTable")}
                        icon={<i className='pi pi-refresh'></i>}
                        onClick={() => clear()}
                    />
                    {isCrud ? (
                        <>
                            {!removeItem.includes('Print') &&
                                <M_Button
                                    tooltip={t("Print")}
                                    label={t("Print")}
                                    icon={<i className='pi pi-print'></i>}
                                    onClick={handleClickOpenMenuPrint}
                                />
                            }
                            <Menu
                                anchorEl={anchorEl}
                                open={openMenuPrint}
                                onClose={handleCloseMenuPrint}
                                className="menuExcel"
                            >
                                {/* {permissions.includes('Create') && !removeItem.includes('Create') &&
                                    <MenuItem className='menuItem'>
                                        <input
                                            className='importExcel'
                                            type="file"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                            // onChange={importExcel}
                                        />
                                        {t("ImportExcel")}
                                    </MenuItem>
                                } */}
                                <MenuItem className='menuItem' onClick={exportExcel}>
                                    {t("ExportExcel")}
                                </MenuItem>
                            </Menu>
                            {permissions.includes('Create') && !removeItem.includes('Create') &&
                                <M_Button
                                    tooltip={t("Add")}
                                    label={t("Add")}
                                    icon={<AddCircleOutlineOutlined style={{ color: 'var(--color-green-light)' }} />}
                                    onClick={replaceFunctions?.get('Create') ? () => replaceFunctions?.get('Create')() : () => handleOpenDialogAdd()}
                                />
                            }
                            {permissions.includes('Edit') && !removeItem.includes('Edit') &&
                                <M_Button
                                    tooltip={t("Edit")}
                                    label={t("Edit")}
                                    icon={<i className='pi pi-pencil iconTable'></i>}
                                    onClick={replaceFunctions?.get('Edit') ? () => replaceFunctions?.get('Edit')(selectedRows[selectedRows.length - 1]) : () => handleOpenEdit(selectedRows.pop())}
                                />
                            }
                            {permissions.includes('Delete') && !removeItem.includes('Delete') &&
                                <M_Button
                                    tooltip={t("Delete")}
                                    label={t("Delete")}
                                    icon={<i className='pi pi-trash iconTable'></i>}
                                    onClick={replaceFunctions?.get('Delete') ? () => replaceFunctions?.get('Delete')(selectedRows) : () => handleOpenDelete(selectedRows)}
                                />
                            }
                            {permissions.includes('Create') && !removeItem.includes('Copy') &&
                                <M_Button
                                    tooltip={t("Copy")}
                                    label={t("Copy")}
                                    icon={<i className='pi pi-copy iconTable'></i>}
                                    onClick={replaceFunctions?.get('Copy') ? () => replaceFunctions?.get('Copy')(selectedRows[selectedRows.length - 1]) : () => handleOpenCopy(selectedRows.pop())}
                                />
                            }
                            {permissions.includes('Create') && !removeItem.includes('Generate Invoice') && entityName === 'Demurrage' && (
                                <M_Button
                                    tooltip={t("Generate Invoice")}
                                    label={t("Generate Invoice")}
                                    icon={<i className='pi pi-calculator iconTable'></i>}
                                    onClick={replaceFunctions?.get('GenerateInvoice')
                                        ? () => replaceFunctions?.get('GenerateInvoice')(selectedRows[selectedRows.length - 1])
                                        : () => handleOpenEdit(selectedRows.pop())}
                                />
                            )}
                            {!removeItem.includes('CheckClearance') && entityName === 'Demurrage' && (
                                <M_Button
                                    tooltip={t("Check Clearance")}
                                    label={t("Check Clearance")}
                                    icon={<i className='pi pi-verified iconTable'></i>}
                                    onClick={replaceFunctions?.get('CheckClearance')
                                        ? () => replaceFunctions?.get('CheckClearance')(selectedRows[selectedRows.length - 1])
                                        : undefined}
                                />
                            )}
                            {!removeItem.includes('CheckDemurrage') && replaceFunctions?.has('CheckDemurrage') && (
                                <M_Button
                                    tooltip={t("Check Demurrage")}
                                    label={t("Check Demurrage")}
                                    icon={<i className='pi pi-check-circle iconTable'></i>}
                                    onClick={replaceFunctions?.get('CheckDemurrage')
                                        ? () => replaceFunctions?.get('CheckDemurrage')(selectedRows)
                                        : undefined}
                                />
                            )}
                            {!removeItem.includes('AddGroupMovement') && replaceFunctions?.has('AddGroupMovement') && (
                                <M_Button
                                    tooltip={t("Add Group Movement")}
                                    label={t("Add Group Movement")}
                                    icon={<i className='pi pi-objects-column iconTable'></i>}
                                    onClick={replaceFunctions?.get('AddGroupMovement')
                                        ? () => replaceFunctions?.get('AddGroupMovement')(selectedRows)
                                        : undefined}
                                />
                            )}
                            {!removeItem.includes('ChangeGroupMovement') && replaceFunctions?.has('ChangeGroupMovement') && (
                                <M_Button
                                    tooltip={t("Change Group Movement")}
                                    label={t("Change Group Movement")}
                                    icon={<i className='pi pi-pen-to-square iconTable'></i>}
                                    onClick={replaceFunctions?.get('ChangeGroupMovement')
                                        ? () => replaceFunctions?.get('ChangeGroupMovement')(selectedRows)
                                        : undefined}
                                />
                            )}
                        </>
                    ) : ''}
                    {newButtons.map((btn, index) =>
                        btn.element === 'default' ?
                            <div key={index}>
                                <M_Button
                                    tooltip={btn.label}
                                    label={btn.label}
                                    icon={btn?.icon ? btn?.icon : <img style={btn.style} src={btn.source} alt={btn.label} className="iconTable" />}
                                    onClick={() => extraButtonFunction(selectedRows[selectedRows.length - 1], btn.command, btn?.needLine)}
                                />
                                {btn.extraEl !== null ?
                                    btn.extraEl
                                    : ''}
                            </div>
                            : btn.element
                    )}
                    {/* {isCrud && permissions.includes('Audit') && !removeItem.includes('Audit') &&
                        <M_Button
                            tooltip={t("Audit")}
                            label={t("Audit")}
                            icon={<i className='pi pi-search iconTable'></i>}
                            onClick={replaceFunctions?.get('Audit') ? replaceFunctions?.get('Audit') : () => getAudit(selectedRows.pop())}
                        />} */}
                </div>
                <div className="menuSearch">
                    {selectedView}
                    <M_Button
                        tooltip={t("Views")}
                        label={t("Views")}
                        icon={<PushPinOutlined style={{ transform: 'rotate(45deg)' }} />}
                        onClick={handleClickOpenViews}
                    />
                    <M_Button
                        id={'advFilter'}
                        tooltip={t("Filters")}
                        label={t("Filters")}
                        icon={
                            <Badge anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                badgeContent={metaPair.length}
                                sx={{
                                    "& .MuiBadge-badge": {
                                        color: "var(--color-white)",
                                        backgroundColor: `${color ? color : "var(--color-black)"}`
                                    }
                                }} >
                                <i className='pi pi-filter'></i>
                            </Badge>
                        }
                        onClick={handleOpenAdvancedFilterMenu}
                    />
                    <M_Button
                        tooltip={t("editColumns")}
                        label={t("editColumns")}
                        icon={<i className='pi pi-eye'></i>}
                        onClick={handleClickOpenMenuHideColumns}
                    />
                    <Menu
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        transformOrigin={{ vertical: "top", horizontal: "center" }}
                        anchorEl={anchorEls}
                        open={openMenuHideColumns}
                        onClose={handleCloseMenuHideColumns}
                        className="organizeMenuSearchTable"
                        MenuListProps={{ disablePadding: true }}
                    >
                        <div className='stickyTopTable'>
                            <MenuItem disableRipple={true} className="organizeMenuItem" >
                                <InputBase
                                    onChange={(e) => { filterColumnModal(e.target.value) }}
                                    placeholder={t("Search")}
                                    className='organizeInputBase'
                                    inputProps={{ 'aria-label': 'Search Columns' }}
                                    value={valueFilteredColumnModal}
                                    startAdornment={
                                        <InputAdornment position="start"> <Search /> </InputAdornment>
                                    }
                                />
                            </MenuItem>
                        </div>
                        {filteredColumnModal.map((col, index) => (
                            <div className='menuSwtchs menuItem' key={index}>
                                <M_SwitchButton
                                    label={col.NormalizedName}
                                    color={color ? color : "var(--color-black)"}
                                    checked={isColumnChecked(col.name)}
                                    onClick={(event) => onColumnToggle(col, event)}
                                    disabled={isMandatoryColumn(col.name)}
                                    tooltipName={isMandatoryColumn(col.name) ? t('MandatoryColumn') : ''}
                                />
                            </div>
                        ))}
                    </Menu>
                    <Menu
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        transformOrigin={{ vertical: "top", horizontal: "center" }}
                        anchorEl={anchorV}
                        open={openMenuViews}
                        onClose={handleClickCloseViews}
                        className="menuViews"
                        MenuListProps={{ disablePadding: true }}
                    >
                        <div className='stickyTop center'>
                            <MenuItem disableRipple={true} className="cursorDefault viewsLabel" >
                                {t("Views")}
                            </MenuItem>
                        </div>
                        <div className='midleViews menuitem'>
                            <div className='viewsMasterDiv'>
                                <div
                                    style={selectedView === 'Default' ?
                                        { border: `1px solid ${color ? color : "var(--color-black)"}`, backgroundColor: `${color ? color : "var(--color-black)"}` } :
                                        { border: '1px solid var(--color-grey-light)', backgroundColor: 'transparent' }}
                                    className={selectedView === 'Default' ? 'defaultViewdiv' : 'defaultUnselectedViewDiv'}
                                    onClick={() => { changeView('Default') }}
                                >
                                    <span className={selectedView === 'Default' ? 'spanSelectedView' : 'unselectSpanView'}> Default </span>
                                </div>
                            </div>
                        </div>
                        {Object.keys(Object.fromEntries(views)).map((col, index) => (
                            <div className='midleViews menuitem' key={index}>
                                {col !== 'Default' ?
                                    <div className='viewsMasterDiv'>
                                        <div
                                            style={selectedView === col ?
                                                { border: `1px solid ${color ? color : "var(--color-black)"}`, backgroundColor: `${color ? color : "var(--color-black)"}` } :
                                                { border: '1px solid var(--color-grey-light)' }}
                                            className={selectedView === col ? 'selectedViewsDiv' : 'unselectViewSpan'}
                                            onClick={() => { changeView(col) }}
                                        >
                                            <span className={selectedView === col ? 'spanSelectedView' : 'unselectSpanView'}> {col} </span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <M_Button hoverEffect none icon={<Close />} onClick={() => deleteView(col)} borderColor={selectedView === col ? `${color ? color : "var(--color-black)"}` : 'var(--color-grey-light)'} />
                                        </div>
                                    </div>
                                    : ''
                                }
                            </div>
                        ))}
                        <div className='stickyBot center' style={{ marginBottom: '5px' }} >
                            <M_Button
                                icon={<i className="pi pi-plus-circle" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                                hoverEffect
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                                onClick={(e) => createView(e)}
                                label={`${t('CreateNewView')}`}
                                width={25}
                            />
                        </div>
                    </Menu>
                </div>
                <div>
                    <AdvanceFilter
                        color={color ? color : "var(--color-black)"}
                        onDeleteFilter={deleteFilter}
                        onDeleteAllFilters={deleteAllFilters}
                        onSubmitFilters={submitFilters}
                        onAddMetaPair={addMetaPair}
                        metaPair={metaPair}
                        metaType={metaType}
                        showFilters={showFilters}
                        anchorAF={anchorAF}
                        setAnchorAF={setAnchorAF}
                        onSaveFilter={saveFilter}
                        selectedView={selectedView}
                        views={views}
                        onToasts={(type, alert, string) => toastMessages(type, alert, string)}
                    />
                </div>
            </div>
            <div>{extraTopFields}</div>
        </div>
    )

    const RenderAuditFields = ({ fields, depth = 0 }) => {
        if (!Array.isArray(fields) || fields.length === 0) return null
        return fields.map((f, i) => {
            const key = f?.Id || `${depth}-${i}-${f?.Field || 'field'}`
            const hasChildren = Array.isArray(f?.FieldsList) && f.FieldsList.length > 0
            if (hasChildren) {
                return (
                    <Accordion key={key} sx={{ border: '1px dashed var(--color-grey-dark)', borderRadius: '8px', mb: 1, ml: `${depth * 12}px` }}>
                        <AccordionSummary expandIcon={<ArrowDownward />}>
                            <div style={{ display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%', width: '100%' }}>
                                <div><strong>{t("Field")}:</strong> {f.Field}</div>
                                <div><strong>{t("OldValue")}:</strong> {f.OldValue ?? 'null'}</div>
                                <div><strong>{t("NewValue")}:</strong> {f.NewValue ?? 'null'}</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: i % 2 ? 'var(--color-grey-light)' : 'transparent' }}>
                            <RenderAuditFields fields={f.FieldsList} depth={depth + 1} />
                        </AccordionDetails>
                    </Accordion>
                )
            }
            return (
                <AccordionDetails key={key} sx={{ backgroundColor: i % 2 ? 'var(--color-grey-light)' : 'transparent', borderBottomLeftRadius: (i + 1 === fields.length) ? '10px' : undefined, borderBottomRightRadius: (i + 1 === fields.length) ? '10px' : undefined }}>
                    <div style={{ color: 'var(--color-black)', display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ fontSize: '12px', marginRight: '10px' }}>{t("Field")}:</div>
                            <div style={{ userSelect: 'all', fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'wrap' }}>{f.Field}</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ fontSize: '12px', marginRight: '10px' }}>{t("OldValue")}:</div>
                            <div style={{ userSelect: 'all', fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'wrap' }}>{f.OldValue ?? 'null'}</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ fontSize: '12px', marginRight: '10px' }}>{t("NewValue")}:</div>
                            <div style={{ userSelect: 'all', fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'wrap' }}>{f.NewValue ?? 'null'}</div>
                        </div>
                    </div>
                </AccordionDetails>
            )
        })
    }

    const getAudit = (line) => {
        if (!line) { ctx.toastMessages('error', '', t("SelectedLine")); return }
        ctx.setIsLoad(true)
        const auditId = line?.IdBooking ?? line?.Id
        auditService.getId(auditId).then(resAudit => {
            if (Array.isArray(resAudit)) {
                setAuditData(resAudit)
                setOpenAudit(true)
                ctx.setIsLoad(false)
            } else {
                ctx.toastMessages('error', '', t("noAudit"))
                ctx.setIsLoad(false)
            }
        })
    }

    const closeAudit = () => {
        setOpenAudit(false)
        setAuditData([])
    }

    const verifiedBodyTemplate = (rowData, field) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <M_CheckBox disabled checked={rowData[field]} />
        </div>
    )

    const statusBodyTemplate = (rowData, field) => (
        <div style={{ display: 'flex', fontWeight: 'bolder', color: 'white', justifyContent: 'center', textAlign: 'center', alignItems: 'center', borderRadius: '6px', padding: '3px 10px', fontSize: '0.8rem', backgroundColor: getSeverity(rowData[field]) }}>
            {rowData[field]}
        </div>
    )

    const dateBodyTemplate = (rowData, field) => {
        const value = rowData[field]
        if (!value) return ''
        if (typeof value === 'string' && value.includes('T')) return value.split('T')[0]
        return value
    }

    const headerElement = (col, iconForm) => {
        if (col.Type !== 'boolean' && col.Type !== 'string' && col.Type !== 'int32' && col.Type !== 'datetime') {
            return (
                <div id='columnTable' title={col.Header} style={{ display: 'flex', cursor: 'pointer' }}>
                    <div id='columnTable' title={col.Header} style={{ marginRight: '10px' }}>{col.NormalizedName}</div>
                </div>
            )
        }
        return (
            <div onClick={(e) => order(e)} id='columnTable' title={col.Header} style={{ display: 'flex', cursor: 'pointer' }}>
                <div id='columnTable' title={col.Header} style={{ marginRight: '10px' }}>{col.NormalizedName}</div>
                {iconForm === 'asc' ? (<i id='columnTable' title={col.Header} className="pi pi-sort-amount-down "></i>) :
                    iconForm === 'desc' ? (<i id='columnTable' title={col.Header} className="pi pi-sort-amount-up "></i>) :
                        (<i id='columnTable' title={col.Header} className="pi pi-sort-alt"></i>)}
            </div>
        )
    }

    const dynamicColumns = selectedColumns.map((col, i) => {
        let iconForm = 'default'
        if (orderInfo.columnName === col.Header) {
            iconForm = orderInfo.orderbool === false ? 'asc' : 'desc'
        }
        const template = columnTemplates.find(t => t.field === col.Name || t.field === col.NormalizedName)
        if (template && template.body) {
            return (
                <Column id='head' key={i} dataType={col.Type} field={col.Name}
                    header={headerElement(col, iconForm)} showAddButton={true} body={template.body}
                    headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }} />
            )
        }
        if (col.Type === 'boolean') {
            return (
                <Column id='head' key={i} dataType={col.Type} field={col.Name}
                    header={headerElement(col, iconForm)} body={(data) => verifiedBodyTemplate(data, col.Name)}
                    headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }} />
            )
        }
        if (col.NormalizedName == 'Status') {
            return (
                <Column id='head' key={i} dataType={col.Type} field={col.Name}
                    header={headerElement(col, iconForm)} showAddButton={true} body={(data) => statusBodyTemplate(data, col.Name)}
                    headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }} />
            )
        }
        if (col.Type === 'datetime') {
            return (
                <Column id='head' key={i} dataType={col.Type} field={col.Name}
                    header={headerElement(col, iconForm)} body={(data) => dateBodyTemplate(data, col.Name)}
                    headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }} />
            )
        }

        if (col.Type === 'datetime') {
            return (
                <Column
                    id='head'
                    key={i}
                    dataType={col.Type}
                    field={col.Name}
                    header={headerElement(col, iconForm)}
                    showAddButton={true}
                    body={(data) => data[col.Name] ? data[col.Name].slice(0, 10) : ''}
                    headerStyle={{
                        borderBottom: `2px solid ${color}`,
                        color: secondColor
                    }}
                ></Column>
            )
        }

        return (
            <Column id='head' key={i} dataType={col.Type} field={col.Name}
                header={headerElement(col, iconForm)} showAddButton={true}
                headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }} />
        )
    })

    const rebuildContextMenu = () => {
        const tempArray = []
        if (!removeItem.includes('View')) {
            tempArray.push({ label: t("view"), icon: (<i className='pi pi-search' style={{ color: color, marginRight: '0.5rem' }}></i>), command: replaceFunctions?.get('View') ? () => { replaceFunctions?.get('View')(selectContext) } : () => handleView(selectContext) })
        }
        if (permissions.includes('Edit') && !removeItem.includes('Edit')) {
            tempArray.push({ label: t("Edit"), icon: 'pi pi-pencil', command: replaceFunctions?.get('Edit') ? () => { replaceFunctions?.get('Edit')(selectContext) } : () => handleOpenEdit(selectContext) })
        }
        if (permissions.includes('Create') && !removeItem.includes('Create') && !removeItem.includes('Copy')) {
            tempArray.push({ label: t("Copy"), icon: 'pi pi-copy', command: replaceFunctions?.get('Copy') ? () => { replaceFunctions?.get('Copy')(selectContext) } : () => handleOpenCopy(selectContext) })
        }
        if (permissions.includes('Delete') && !removeItem.includes('Delete')) {
            tempArray.push({ label: t("Delete"), icon: 'pi pi-trash', command: replaceFunctions?.get('Delete') ? () => { replaceFunctions?.get('Delete')(selectContext) } : (obj, data) => constextDeleteButton(obj, data) })
        }
        tempArray.push(...contextMenu)
        if (permissions.includes('Audit') && !removeItem.includes('Audit')) {
            tempArray.push({ separator: true })
            tempArray.push({ label: t("Audit"), icon: 'pi pi-search', command: () => getAudit(selectContext) })
        }
        return tempArray
    }

    const constextDeleteButton = (event, data) => {
        const tempObj = { ...selectContext }
        setDataContextMenu(tempObj)
        handleOpenDelete(selectContext)
    }

    const defaultStyle = { position: 'absolute', overflow: 'hidden', height: '100%', width: '100%', zIndex: '5000000', backgroundColor: 'var(--color-grey-light)', opacity: '0.7' }
    const loadingStyle = { ...defaultStyle, height: '100vh' }
    const hideStyle = { ...defaultStyle, display: 'none' }
    const mainStyle = adjustingTableMedia2 ? { ...loadingStyle, top: '50px' } : { ...loadingStyle, top: '0px' }

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (
                <div>
                    <ContextMenu model={columnContextMenu} onShow={e => cm.current.hide(e.originalEvent)} ref={ccm} />
                    <ContextMenu model={rebuildContextMenu()} onShow={e => ccm.current.hide(e.originalEvent)}
                        onHide={(e) => {
                            if (e && e.target.className !== 'p-menuitem-link') {
                                if (onPassContext) onPassContext(null)
                                sessionStorage.removeItem('contextLine')
                            }
                            setSelectContext(null)
                        }} ref={cm}
                    />
                    {isTable ?
                        <div className='secondDivDataTable' onContextMenu={(e) => { rightClick(e) }}>
                            <DataTable
                                className='defaultTable'
                                tableStyle={{ width: '100%' }}
                                header={header}
                                value={rows}
                                size="small"
                                selection={selectedRows}
                                selectionMode="multiple"
                                stripedRows
                                responsiveLayout="scroll"
                                breakpoint="960px"
                                scrollHeight={height}
                                reorderableColumns
                                onColReorder={onColReorder}
                                ref={dt} //necessário para o export de CSV
                                onSelectionChange={onSelectionChange}
                                onContextMenuSelectionChange={e => {
                                    sessionStorage.setItem('contextLine', JSON.stringify(e.value))
                                    setSelectContext(e.value)
                                    if (onPassContext) onPassContext(e.value)
                                }}
                                onContextMenu={e => cm.current.show(e.originalEvent)}
                                onRowDoubleClick={onRowDoubleClick ? (e) => onRowDoubleClick(e.data) : undefined}
                            >
                                {isSelectSingle ?
                                    <Column headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }} selectionMode="single" className='OpenTableCheckbox' frozen />
                                    :
                                    <Column headerStyle={{ borderBottom: `2px solid ${color}`, color: secondColor }} selectionMode="multiple" className='TableSelectionColumn' frozen />
                                }
                                {dynamicColumns}
                            </DataTable>
                            <Paginator
                                className='paginator'
                                rows={pageSize}
                                totalRecords={totalRows}
                                first={firstRows}
                                onPageChange={(e) => onPage(e)}
                            />
                        </div>
                        :
                        CrudComponent ?
                            <CrudComponent
                                metaType={metaType}
                                entity={entity}
                                onGetWithFilters={getWithFilters}
                                onToastMessages={toastMessages}
                                operation={operation}
                                setIsTable={setIsTable}
                                rowEdit={rowEdit}
                                setRowEdit={setRowEdit}
                                valueAdd={valueAdd}
                                setValueAdd={setValueAdd}
                                isCopy={isCopy}
                                setIsCopy={setIsCopy}
                                editMap={editMap}
                                setEditMap={setEditMap}
                                row={row}
                                isChildTable={isChildTable}
                                parentLine={parentLine}
                                field={field}
                                companies={companies}
                                hasConfirmation={hasConfirmation}
                            />
                            :
                            <CrudTable
                                metaType={metaType}
                                entity={entity}
                                onGetWithFilters={getWithFilters}
                                onToastMessages={toastMessages}
                                operation={operation}
                                setIsTable={setIsTable}
                                rowEdit={rowEdit}
                                setRowEdit={setRowEdit}
                                valueAdd={valueAdd}
                                setValueAdd={setValueAdd}
                                isCopy={isCopy}
                                setIsCopy={setIsCopy}
                                editMap={editMap}
                                setEditMap={setEditMap}
                                row={row}
                                isChildTable={isChildTable}
                                parentLine={parentLine}
                                field={field}
                                companies={companies}
                                hasConfirmation={hasConfirmation}
                                api={api}
                            />
                    }
                    <M_MessageBoard
                        warning
                        open={openConfirmDelete}
                        onClose={handleCloseConfirmDelete}
                        title={<div style={{ color: 'var(--color-red-dark)' }}>{t("Delete")} {t(entityName)} ?</div>}
                        body={<span>{t("TitleConfirmDelete")} <b>{entityName}</b></span>}
                        footer={
                            <span style={{ display: 'flex' }}>
                                <M_Button normal hoverEffect label={t("ButtonCancel")}
                                    backgroundColor={'var(--color-white)'} borderColor={'var(--color-grey-dark2)'}
                                    labelColor={'var(--color-grey-dark2)'} onClick={handleCloseConfirmDelete} />
                                <M_Button normal hoverEffect width={20} label={t("Delete")}
                                    backgroundColor={'var(--color-red)'} borderColor={'var(--color-red)'}
                                    labelColor={'var(--color-white)'} onClick={postDelete} />
                            </span>
                        }
                    />
                    <M_MessageBoard
                        open={openAudit}
                        onClose={closeAudit}
                        minWidth={'80vw'}
                        maxWidth={!breakAuditWidth2 && '100vw'}
                        top={!breakAuditWidth && breakAuditWidth2 && '0'}
                        left={!breakAuditWidth && breakAuditWidth2 && '0'}
                        body={
                            <div style={{ height: '70vh', overflow: 'auto', width: '100%' }}>
                                <div style={{ width: '100%', height: '60vh' }}>
                                    <h1 style={{ display: 'flex', justifyContent: 'center' }}>{entityName} Audit</h1>
                                    {auditData?.sort((a, b) => Date.parse(a?.CreationDate) - Date.parse(b?.CreationDate))?.map((obj, index) => (
                                        <Accordion key={index} sx={{ border: '1px solid var(--color-black)', borderRadius: '10px !important', marginBottom: '20px', scrollbarWidth: '0px' }}>
                                            <AccordionSummary expandIcon={<ArrowDownward />}>
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <div style={{ display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%', alignItems: 'center', width: '100%', marginBottom: '10px' }}>
                                                        <div style={{ display: 'flex' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px', alignItems: 'center' }}>{t("Action")}:</div>
                                                            <div style={{ color: obj.Action == 'Create' ? 'var(--color-green)' : obj.Action == 'Update' ? 'var(--color-yellow)' : 'var(--color-black)', fontWeight: 'bolder' }}>{obj.Action}</div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>{t("CreatedByEmail")}:</div>
                                                            <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'wrap' }}>{obj.CreatedByEmail}</div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{ fontSize: '12px', marginRight: '10px' }}>{t("On")}:</div>
                                                            <div>{obj.CreationDate.replace('T', ' ').split('.')[0]}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </AccordionSummary>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div style={{ width: '80%', borderBottom: `2px solid var(--color-black)`, marginBottom: '10px' }}></div>
                                            </div>
                                            <RenderAuditFields fields={obj.AuditFields} />
                                        </Accordion>
                                    ))}
                                </div>
                                <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
                                    <M_Button none icon={<CloseRounded style={{ color: 'var(--color-red)', scale: '1.5' }} color='var(--color-red)' />} onClick={closeAudit} />
                                </div>
                            </div>
                        }
                    />
                </div>
            )}
            <div style={loading ? mainStyle : hideStyle}>
                <LoadingBar />
            </div>
        </>
    )
}